// extracted by mini-css-extract-plugin
module.exports = {"required_tfa_modal":"RedirectToTfaActivationModal_required_tfa_modal__DJCRC","required_tfa_modal__container":"RedirectToTfaActivationModal_required_tfa_modal__container__9LmTs"};